export enum ReviewByIdQueryParamsKeyEnum {
  reviewAction = "review-action",
  reviewId = "review-id",
}

export enum ReviewByIdQueryParamsValueEnum {
  add = "add",
  edit = "edit",
}
